import { Code, ConnectError } from '@connectrpc/connect'
import { QueryClient } from '@tanstack/react-query'

/** Errors a retry cannot fix; everything else (Unavailable, network) retries twice. */
const NO_RETRY = new Set<Code>([
  Code.Unauthenticated,
  Code.PermissionDenied,
  Code.NotFound,
  Code.InvalidArgument,
  Code.FailedPrecondition,
  Code.ResourceExhausted,
  Code.Unimplemented,
])

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ConnectError && NO_RETRY.has(error.code)) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      staleTime: 10_000,
    },
  },
})
